import React from "react";
import { BUTTONS_TYPE } from "Constants";
import { StyledButton } from "components";

import { useTranslation } from "localization/translation";

const AboutPlan = (props) => {
  const {
    name_hy,
    name_en,
    name_ru,
    active,
    trial_period_days,
    max_inventory_items_ml,
    max_inventory_items_kg_pc,
    unlimited_items,
    actionHandler,
    actionStatusChange,
    loadingChangeStatus,
  } = props;
  const translation = useTranslation();
  
  return (
    <div className="about_plan pr-4">
      <div className="align-create-btn-between-date">
        <div className="company_filed">
          <h6 className="font-weight-bold font-size-lg mb-0 text-black text-capitalize">
            {translation.plan_information} - {active ? translation.active : translation.deactive}
          </h6>
        </div>
        <div className="user_actions align-create-btn-between-date">
          <div className="activate_field mr-4">
            <StyledButton
              className={active ? BUTTONS_TYPE.deactive : BUTTONS_TYPE.active}
              name={active ? translation.deactivate : translation.activate}
              onClick={actionStatusChange}
              disabled={loadingChangeStatus}
            />
          </div>
          <div className="activate_field">
            <StyledButton
              className={BUTTONS_TYPE.edit}
              name={translation.edit}
              onClick={actionHandler}
            />
          </div>
        </div>
      </div>
      <div className="informative_section">
        <div className="informative_title">
          <p className="font-weight-bold plan_info_text">
            Name (Armenian)
          </p>
          <p className="font-weight-bold plan_info_text">
            Name (English)
          </p>
          <p className="font-weight-bold plan_info_text">
            Name (Russian)
          </p>
          <p className="font-weight-bold plan_info_text">
            Trial period days
          </p>
          <p className="font-weight-bold plan_info_text">
            Max inventory items
          </p>
          <p className="font-weight-bold plan_info_text">
            Unlimited items
          </p>
        </div>
        <div className="informative_text">
          <p className="font-size-sm plan_info_text">{name_hy}</p>
          <p className="font-size-sm plan_info_text">{name_en}</p>
          <p className="font-size-sm plan_info_text">{name_ru}</p>
          <p className="font-size-sm plan_info_text">{trial_period_days}</p>
          <p className="font-size-sm plan_info_text">
            {max_inventory_items_ml}({translation.ml}) / {max_inventory_items_kg_pc}({translation.kg}/{translation.pc})
          </p>
          <p className="font-size-sm plan_info_text">{unlimited_items ? 'true' : 'false'}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPlan;
